import React from 'react';

import 'index.css';
import './Controls.css';
import PlayBtn from './PlayBtn';
import PauseBtn from './PauseBtn';
import ProgressBar from './ProgressBar';
import MuteBtn from './MuteBtn';
import FullScreenBtn from './FullScreenBtn';

import RetrieveTimePosition from './RetrieveTimePosition';

const Controls = ({
  paused,
  playerState,
  onPlay,
  onPause,
  onPositionUpdate,
  moveDisabled,
  direct,
  directMin,
  visibleTimestamp,
  fullScreenDisabled,
  node,
  onExitfullscreen,
  onMute,
  onUnMute,
  onVolumeChange,
  volume,
  currentTime,
  actuallyPaused,
  duration,
  onFullScreen,
  timePosition,
  withTooltip,
}) => {
  const actuallyPausedHandled = playerState ? playerState.actuallyPaused : actuallyPaused;
  const waitForPlay = !paused && actuallyPausedHandled;
  const shouldDisplayRetrieveButton = timePosition && Math.abs(currentTime - timePosition) > 300;

  return [
    <span key="playpause" className="controls-playpause">
      <PlayBtn onPlay={onPlay} playing={!paused} waitForPlay={waitForPlay} />
      <PauseBtn onPause={onPause} playing={!paused} />
    </span>,
    <ProgressBar
      key="progressbar"
      currentTime={playerState ? playerState.currentTime : currentTime}
      duration={playerState ? playerState.duration : duration}
      onPositionUpdate={onPositionUpdate}
      moveDisabled={moveDisabled}
      direct={direct}
      directMin={directMin}
      visibleTimestamp={visibleTimestamp}
      withTooltip={withTooltip}
    />,
    <span key="mute-fullscreen" className="controls-mute-fullscreen">
      {!fullScreenDisabled && (
        <FullScreenBtn
          onFullScreen={onFullScreen}
          node={node}
          onExitfullscreen={() => onExitfullscreen && onExitfullscreen()}
        />
      )}
      <MuteBtn
        onMute={onMute}
        onUnMute={onUnMute}
        onVolumeChange={onVolumeChange}
        muted={volume === 0}
        volume={volume}
      />
    </span>,
    <div key="retrieve-time-position" className="retrieve-time">
      {shouldDisplayRetrieveButton && (
        <RetrieveTimePosition
          timePosition={timePosition}
          retrieve={timePosition => onPositionUpdate(timePosition, false)}
        />
      )}
    </div>,
  ];
};

export default Controls;
